import React from 'react'

import MarkdownHelper from '../../utils/MarkdownHelper'
import ReactMarkdown from "react-markdown"

import { FootnotesFromContext } from "../../subcomponents/Footnotes";

import {default as t} from '../../utils/Translate'
import { useSuperscript } from '../../utils/SuperscriptHelper';

const TeaserDidYouKnow = ({campaign, lang, footnotesWarningText}) => {
    const campaignWithSuperscript = {
        ...campaign,
        title_2_short: useSuperscript(campaign.title_2_short, true),
        copy_short: useSuperscript(campaign.copy_short, true),
    }

    return (
        <div>
            <div className="teaser-did-you-know bg-white border px-md py-md">

                <div className="teaser-did-you-know__image mr-md">
                    <img alt="image_top_offer"
                         src={campaign.image_16_9} />
                </div>
                <div className="teaser-did-you-know__content flex-fill">
                    <h2 className="teaser-did-you-know__content__headline">
                        <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                       source={t(campaignWithSuperscript.title_2_short, lang)}
                                       escapeHtml={false} />
                    </h2>
                    <p className="teaser-did-you-know__content__text">
                        <ReactMarkdown {...MarkdownHelper.allTypes()}
                                       source={t(campaignWithSuperscript.copy_short, lang)} />
                    </p>

                </div>
            </div>
            <FootnotesFromContext showWarningText={footnotesWarningText} />
        </div>
    )

}

export default TeaserDidYouKnow



// WEBPACK FOOTER //
// ./src/components/ads/creditcard/TeaserDidYouKnow.js